import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';

import { submitOnchangeFormQA, submitOnchangeProject } from '../handler/QaTicketHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmChangeDeskOrForm = (props) => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmChangeDeskOrForm(false);
    };

    const onHandlerConfirmChange = () => {
        if (props.dialogConfirmType === Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.HELPDESK) {
            submitOnchangeProject(props.selectedProjectChange, props);
            props.setSelectedProjectChange('');
        } else if (props.dialogConfirmType === Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.FORM) {
            submitOnchangeFormQA(props.selectedFormChange, props);
            props.setSelectedFormChange('');
        }

        props.setIsConfirmChangeDeskOrForm(false);
        props?.clearErrors();
    }

    return (
        <Dialog
            open={props.isConfirmChangeDeskOrForm}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {props.dialogConfirmType === Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.HELPDESK ? trI18n('USER04MSG016') : trI18n('USER04MSG017')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onHandlerConfirmChange(props)}
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
